import { fixedUi } from '@/i18n/fixedUi';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import {
  buildTemuPath,
  parseTemuShopTypeSlugFromPath,
  resolveTemuModuleSupport,
  shopTypeLabelForSlug,
} from '@/temu-platform/constants/temuRoutes';

/**
 * 模块级店铺类型守卫。
 *
 * <p>侧栏已经按 {@link resolveTemuModuleSupport} 裁剪菜单，但旧收藏、跨店铺类型切换后的
 * 历史 URL、「全部店铺」跳到具体店铺等路径仍可能直链到当前店铺类型不支持的模块。
 * 这里前置拦截，避免用错误的 OpenAPI type 去打平台（表现为 7000019 no access
 * 或接口调通但列表永远为空），同时也避免页面上残留上一次渲染的数据。
 */
export default function TemuModuleTrackGuard({ children }) {
  const { shopType } = useParams();
  const location = useLocation();
  const slug = parseTemuShopTypeSlugFromPath(location.pathname) || shopType;
  const support = resolveTemuModuleSupport(slug, location.pathname);

  if (support.supported) {
    return children;
  }

  const allowedLabels = (support.allowedSlugs || [])
    .map((item) => shopTypeLabelForSlug(item))
    .filter(Boolean)
    .join(' / ');

  // slugs 为空 = 该模块对所有店铺类型都不可用（例如活动API组仅自研应用可用），
  // 此时不能说「不适用于当前店铺类型」，否则会误导用户去切店铺类型重试。
  const unavailableForAll = !allowedLabels && (support.allowedSlugs || []).length === 0;

  return (
    <div className="tpo-certs-empty" data-testid="temu-module-track-guard">
      <p className="tpo-certs-empty__title">
        {unavailableForAll
          ? `「${support.moduleLabel}」当前不可用`
          : `「${support.moduleLabel}」不适用于${shopTypeLabelForSlug(slug) || fixedUi("当前")}店铺`}
      </p>
      <p className="tpo-certs-empty__hint">
        {support.reason}
        {allowedLabels ? `，该模块仅支持${allowedLabels}店铺。` : '。'}
      </p>
      <div style={{ marginTop: 12 }}>
        <a className="tpo-btn tpo-btn--primary tpo-btn--sm" href={buildTemuPath(slug, 'home')}>
          返回首页
        </a>
      </div>
    </div>
  );
}
